export function isMobileWebview(): boolean {
  return window.ReactNativeWebView?.postMessage !== undefined;
}
